export const API =
  process.env.NODE_ENV === "production"
    ? "https://api.fillter.me"
    : "http://localhost:8080";
